import React, { useState } from "react";
import { ReactComponent as HamburgerSvg } from "../../assets/svg/hamburger.svg";
import { ReactComponent as LogoutSvg } from "../../assets/svg/logout.svg";

import { LogoImage } from "../../assets/images";
import { useLocation, useNavigate } from "react-router-dom";
import { protectedHttp } from "../../helpers/http.helper";

const AdminTopbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);

  const logoutClient = async () => {
    if (window.confirm("Are you sure to logout?")) {
      protectedHttp
        .post("/auth/signout")
        .then(() => {
          localStorage.removeItem("uu_session");
          navigate("/");
        })
        .catch((err) => console.log(err.response.data.msg));
    }
  };

  return (
    <div className="nav-bar-wrapper">
      <div className="nav-bar-container">
        <img
          src={LogoImage}
          alt="Logo EscortHub"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />

        <button className="profile-toggle menu-toggle" onClick={() => setOpenMenu(!openMenu)}>
          <i className="svg-wrapper">
            <HamburgerSvg />
          </i>
        </button>

        <div className="auth-wrapper menu-items" style={{ display: openMenu ? "grid" : "none" }}>
          <span className="glasspane" onClick={() => setOpenMenu(!openMenu)}></span>
          <div>
            <nav className="login-wrapper navigation">
              <li
                onClick={() => {
                  navigate("/admin/dashboard");
                  setOpenMenu(false);
                }}
                className={location.pathname === "/admin/dashboard" ? "active" : ""}
              >
                Dashboard
              </li>
              <li
                onClick={() => {
                  navigate("/admin/all-ads");
                  setOpenMenu(false);
                }}
                className={location.pathname === "/admin/all-ads" ? "active" : ""}
              >
                All Ads
              </li>
              <li
                onClick={() => {
                  navigate("/admin/all-agencies");
                  setOpenMenu(false);
                }}
                className={location.pathname === "/admin/all-agencies" ? "active" : ""}
              >
                Agencies
              </li>
              <li
                onClick={() => {
                  navigate("/admin/all-idependent-escorts");
                  setOpenMenu(false);
                }}
                className={location.pathname === "/admin/all-idependent-escorts" ? "active" : ""}
              >
                Independent Escorts
              </li>
              <li
                onClick={() => {
                  navigate("/admin/partners");
                  setOpenMenu(false);
                }}
                className={location.pathname === "/admin/partners" ? "active" : ""}
              >
                Partners
              </li>
              <li
                onClick={() => {
                  navigate("/admin/links");
                  setOpenMenu(false);
                }}
                className={location.pathname === "/admin/links" ? "active" : ""}
              >
                Links
              </li>
            </nav>
          </div>
        </div>

        <button className="" onClick={logoutClient}>
          <i className="svg-wrapper">
            <LogoutSvg />
          </i>
        </button>
      </div>
    </div>
  );
};

export default AdminTopbar;
